import ws from '../utils/ws';

/* Actions */

export const findInventoryCounts = deviceType => dispatch =>
  dispatch({
    type: FIND_INVENTORY_COUNTS,
    payload: ws.get(`/inventory_counts/device_type/${deviceType}`)
  });

export const adjustInventoryCount = (deviceType, category, delta) => dispatch =>
  dispatch({
    type: ADJUST_INVENTORY_COUNT,
    payload: ws.post('/inventory_counts/adjust', {
      deviceType,
      category,
      delta
    })
  });

/* Action types */

export const FIND_INVENTORY_COUNTS = 'FIND_INVENTORY_COUNTS';
export const FIND_INVENTORY_COUNTS_PENDING = 'FIND_INVENTORY_COUNTS_PENDING';
export const FIND_INVENTORY_COUNTS_FULFILLED = 'FIND_INVENTORY_COUNTS_FULFILLED';

export const ADJUST_INVENTORY_COUNT = 'ADJUST_INVENTORY_COUNT';
export const ADJUST_INVENTORY_COUNT_PENDING = 'ADJUST_INVENTORY_COUNT_PENDING';
export const ADJUST_INVENTORY_COUNT_FULFILLED = 'ADJUST_INVENTORY_COUNT_FULFILLED';
